/* presh-ux100 t171: lift inline !important sub-12px labels (Hear .pk5__k) to 12px */
(()=>{if(window.__preshUX100)return;window.__preshUX100={version:'t171'};
const fix=()=>document.querySelectorAll('.pk5__k').forEach(e=>{if(parseFloat(getComputedStyle(e).fontSize)<12)e.style.setProperty('font-size','12px','important')});
fix();document.addEventListener('DOMContentLoaded',fix);window.addEventListener('load',fix);setTimeout(fix,1500);setTimeout(fix,4000);})();
